interface Props {
  direction: "top" | "bottom" | "left" | "right";
  color: string;
  size?: number;
}

export function Arrow({ direction, color, size = 12 }: Props) {
  const offset = size / 2;
  return (
    <div data-arrow data-placement={direction}>
      <div
        style={{
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: color,
          position: "relative",
          transform: "rotate(45deg)",
          ...(direction === "top" && {
            bottom: `${offset}px`,
          }),
          ...(direction === "bottom" && {
            top: `-${offset}px`,
          }),
          ...(direction === "left" && {
            right: `${offset}px`,
          }),
          ...(direction === "right" && {
            left: `${offset}px`,
          }),
        }}
      />
    </div>
  );
}
